export const NoiseOverlay = () => <div aria-hidden="true" className="noise-overlay" />;
